import React from 'react';
import LinkRenderer from '../LinkRenderer';
import useCTAStyle from '~/hooks/components/use-cta-style';

// reusable CTA button that uses correct analytics based on slug used.
const CTAButtonWithWrapper = ({ callToAction, variant, baseColor, size, forwardSx = {}, ...props }) => {
  // page > innerLink > external (url)
  const { page, innerLink, url, text } = callToAction;

  const isCTAPage = !!page?.slug;
  const isCTAInnerLink = !isCTAPage && innerLink;
  const isCTAExternalLink = !isCTAPage && !isCTAInnerLink && url;

  const CTAStyle = useCTAStyle({
    variant: variant ?? callToAction.variant,
    baseColor: baseColor ?? callToAction.baseColor,
    size: size ?? callToAction.size,
    ...props,
  });

  return (
    <LinkRenderer
      linkType={isCTAExternalLink ? 'external' : null}
      type={isCTAPage ? page.__typename : null}
      page={page ?? {}}
      href={isCTAExternalLink && url}
      innerLink={isCTAInnerLink && innerLink}
      title={isCTAPage ? page.title : isCTAInnerLink ? innerLink : 'external'}
      slug={isCTAPage ? page?.slug : null}
      target={isCTAExternalLink ? '_blank' : null}
      rel={isCTAExternalLink ? 'noreferrer noopener' : null}
      {...props}
      sx={{
        ...CTAStyle,
        ...forwardSx,
      }}
    >
      {text}
    </LinkRenderer>
  );
};

export default CTAButtonWithWrapper;
